<template>
  <div class="home-service">
    <nav-header :activeIndex="6" />
    <main class="home-service-content">
      <router-view></router-view>
      <div class="login-wrapper">
        <div class="login-flex">
          <div class="login-flex-welcome" v-show="showCode">欢迎使用圣诉官网</div>
          <div>
            <!--<div @click="loginCode" v-if="showCode">微信登录</div>-->
            <el-button size="small" type="primary" v-show="showCode" @click="loginCode">微信登录</el-button>
            <div id="login-container" v-show="!showCode" class="login-qrcode" ref="loginContainer"></div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
  import api from './api'
  import NavHeader from '@/common-components/nav-header'
  export default {
    name: 'login',
    components: {
      NavHeader
    },
    data () {
      return {
        showCode: true
      }
    },
    methods: {
      async loginCode () {
        let res = await api.getQRCode()
        if (res) {
          const data = res.data
          let url = ''
          if (process.env.NODE_ENV === 'production') {
            url = 'www.lawhelpads.cn'
          } else {
            url = 'devmk.alphalawyer.cn'
          }
          const wx = new WxLogin({ // eslint-disable-line
            id: 'login-container',
            appid: data.data.appId,
            scope: data.data.scope,
            redirect_uri: encodeURIComponent(`https://wealth.alphalawyer.cn/wechatlogin/${url}/#/login/callback`),
            state: data.data.state,
            style: 'black',
            href: 'https://devev.alphalawyer.cn/wechat/ev.css'
          })
          this.showCode = !this.showCode
          document.querySelector('#login-container iframe').setAttribute('sandbox', 'allow-same-origin allow-top-navigation allow-forms allow-scripts')
        }
      }
    }
  }
</script>

<style lang="stylus">
  .home-service {
    &-content {
      margin-top .72rem
    }
  }
  .login-wrapper {
    background #464c63 url("../../assets/login-background.jpg") no-repeat 50%
    position: relative;
    margin: 0;
    padding: 0;
    height: 100%;
    text-align: center;
    min-height: 4.71rem;
    background-size: cover;
  }
  .login-flex {
    display: inline-block;
    width: 50%;
    float: right;
    min-height: 4.71rem;
    padding-top: 4%;
    text-align: left;
    padding-left: 1rem;
    &-welcome {
      height: .63rem;
      font-size: .45rem;
      letter-spacing: -0.9px;
      color: rgb(255, 255, 255);
      margin-bottom: .3rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue